import { render, staticRenderFns } from "./TransmitForm.vue?vue&type=template&id=9e8fd274"
import script from "./TransmitForm.vue?vue&type=script&lang=js"
export * from "./TransmitForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports